import { Permission, SecurityScope } from '../../../auth/auth.model';
import { AuthService } from '../../../auth/auth.service';
import { PayloadAction } from '../../../store.model';
import { GrantStatusType } from '../../core';
import { getModuleInjector } from '../../evaluation.metadata';
import { ActionType } from '../form.action';
import { FormState } from '../form.state';
import { updateDisplayControls } from '../function/update-display-controls.function';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: FormState,
    _: PayloadAction<ActionType.EVAL_FORM__RELOAD, Reload>,
): FormState {
    return {
        ...state,
        pending: {
            ...state.pending,
            reload: true,
        },
        targetUser: undefined,
        draft: undefined,
        response: undefined,
        form: undefined,
        canEditResponse: undefined,
    };
}

export function reloadResultReducer(
    state: FormState,
    action: PayloadAction<ActionType.EVAL_FORM__RELOAD_RESULT, ReloadResult>,
): FormState {
    try {
        const nextDraft = action.payload.draft;
        const nextResponse = action.payload.response;

        const nextForm = nextDraft?.form ?? nextResponse?.form;
        nextForm.eventDate =
            nextForm.eventDate == null ? null : new Date(nextForm.eventDate);
        nextForm.evaluationDate =
            nextForm.evaluationDate == null
                ? null
                : new Date(nextForm.evaluationDate);

        const service = getModuleInjector().get<AuthService>(AuthService);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        const nextCanEditResponse =
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            nextResponse != null &&
            nextResponse.form?.permissionContext?.overall?.some(
                (e) =>
                    e.permissionId === Permission.EVALUATION_EDIT_PUBLISHED &&
                    e.grantStatusTypeId === GrantStatusType.GRANTED,
            ) &&
            service.user.hasPermission(
                Permission.EVALUATION_EDIT_PUBLISHED,
                SecurityScope.EVALUATIONS,
            );
        const displayControls = updateDisplayControls(
            nextForm?.permissionContext?.overall,
        );
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            targetUser: action.payload.targetUser,
            draft: nextDraft,
            response: nextResponse,
            form: nextForm,
            canEditResponse: nextCanEditResponse,
            displayControls,
            queues: action.payload.queues,
        };
    } catch {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
        };
    }
}
